import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "대상년도", "재해일시", "근속년수", "해당직무근속년수", "복직일", "요양일수", "산재승인여부", "재해속보", "합동조사회의록", "재발방지대책", "개선결과", "위험성평가(개선전)", "위험성평가(개선후)"],
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    if (year) {
      conditions.push({ key: "body.subInfo.재해일시", operator: ">=", value: `${year}-01-01` });
      conditions.push({ key: "body.subInfo.재해일시", operator: "<", value: `${year + 1}-01-01` });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getDefaultSort: () => {
    return [{ target: "$body.subInfo.재해일시", direction: "desc" }];
  },

  /**
   * 목록을 불러온 이후 실제 데이터 값을 list 변수에 저장하기 전에 실행되는 함수 ( this.listAll = response.data 하기 전 )
   * 목록에 표기되는 데이터의 postId 를 배열로 만들어서 944, 945를 조회한다.
   * @param response : 목록데이터
   * @param options : 목록데이터를불러올때사용한옵션
   * @returns {Promise<*>}
   */
  prefixFunc: async (vue, response, options) => {
    const postIds = response.data.map((data) => data.id);
    const newResponse = { ...response };

    if (postIds && postIds.length > 0) {
      const conditions = [];
      conditions.push({ key: "body.connect823Id", operator: "IN", value: postIds });

      const apiOptions = {
        projectId: options.projectId,
        page: 1,
        perPage: options.perPage,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
      };

      // 944, 945 호출
      const [res944, res945] = await Promise.all([vue.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-944` }), vue.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-945` })]);

      const list944 = res944 && res944.data && res944.data.length > 0 ? res944.data.map((data) => JSON.parse(data.post_content)) : [];
      const list945 = res945 && res945.data && res945.data.length > 0 ? res945.data.map((data) => JSON.parse(data.post_content)) : [];

      // 944와 945에 데이터가 존재하는지 찾아 넣는다.
      // ex) [{ 944: true, 945: false}]
      const jsonConnect = {};

      for (let i = 0; i < list944.length; i++) {
        const postId = list944[i].body.connect823Id;
        jsonConnect[postId] = { 944: !!postId };
      }

      for (let i = 0; i < list945.length; i++) {
        const postId = list945[i].body.connect823Id;
        if (postId) {
          jsonConnect[postId][945] = true;
        }
      }

      // response.data 에 otherPosts 추가
      newResponse.data = newResponse.data.map((data) => {
        return {
          ...data,
          otherPosts: jsonConnect[data.id] || { 944: false, 945: false },
        };
      });
    }

    return newResponse;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "재해일시",
        key: "body.subInfo.재해일시",
      },
      {
        name: "재해장소",
        key: "body.subInfo.재해장소",
      },
      {
        name: "구분",
        key: "body.subInfo.구분",
      },
      {
        name: "팀명/업체명",
        key: "body.subInfo.팀명_업체명",
      },
      {
        name: "근속년수",
        key: "body.subInfo.근속년수",
      },
      {
        name: "해당직무근속년수",
        key: "body.subInfo.해당직무근속년수",
        style: { minWidth: "120px" },
      },
      {
        name: "재해유형",
        key: "body.subInfo.재해형태",
        style: { maxWidth: "100px" },
      },
      {
        name: "복직일",
        key: "body.subInfo.복직일",
      },
      {
        name: "요양일수",
        key: "body.subInfo.요양일수",
      },
      {
        name: "산재승인여부",
        key: "body.subInfo.산재승인여부",
      },
      {
        name: "재해속보",
        key: "body.subInfo.재해속보",
      },
      {
        name: "합동조사회의록",
        key: "body.subInfo.합동조사회의록",
        style: { minWidth: "120px" },
      },
      {
        name: "재발방지대책",
        key: "body.subInfo.재발방지대책",
      },
      {
        name: "개선결과",
        key: "body.subInfo.개선결과",
      },
      {
        name: "기타",
        key: "body.subInfo.기타",
      },
      {
        name: "위험성평가(개선전)",
        key: "body.connect944Id",
      },
      {
        name: "위험성평가(개선후)",
        key: "body.connect945Id",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).subInfo.재해일시; // 재해일시
        case 3:
          return func.getContent(value).subInfo.재해장소; // 재해장소
        case 4:
          return func.getContent(value).subInfo.구분; // 구분
        case 5:
          return func.getContent(value).subInfo.팀명_업체명; // 팀명/업체명
        case 6:
          return func.getContent(value).subInfo.근속년수; // 근속년수
        case 7:
          return func.getContent(value).subInfo.해당직무근속년수; // 해당직무근속년수
        case 8:
          return func.getContent(value).subInfo.재해형태; // 재해형태
        case 9:
          return func.getContent(value).subInfo.복직일; // 복직일
        case 10:
          return func.getContent(value).subInfo.요양일수; // 요양일수
        case 11: {
          // 산재승인여부
          const 산재 = func.getContent(value).subInfo.산재승인여부;
          const result = `<span class="text-${산재 === "승인" ? "success" : "danger"}">${산재}</span>`;
          return {
            type: "html",
            html: result,
          };
        }
        case 12: {
          // 재해속보
          const file = func.getContent(value).subInfo.재해속보;
          return {
            type: "docsIcon",
            file,
          };
        }
        case 13: {
          // 합동조사회의록
          const file = func.getContent(value).subInfo.합동조사회의록;
          return {
            type: "docsIcon",
            file,
          };
        }
        case 14: {
          // 재발방지대책
          const file = func.getContent(value).subInfo.재발방지대책;
          return {
            type: "docsIcon",
            file,
          };
        }
        case 15: {
          // 개선결과
          const file = func.getContent(value).subInfo.개선결과;
          return {
            type: "docsIcon",
            file,
          };
        }
        case 16:
          return func.getContent(value).subInfo.기타; // 기타
        case 17: // 개선전
          if (value.otherPosts[944]) return { type: "colorBox", color: "#3C3C3C", text: "완료" };
          else return { type: "colorBox", color: "#FF9F43", text: "미완료" };
        case 18: // 개선후
          if (value.otherPosts[945]) return { type: "colorBox", color: "#3C3C3C", text: "완료" };
          else return { type: "colorBox", color: "#FF9F43", text: "미완료" };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
